import type { ErrorType } from '@/types/errors';

export const STATUS_TO_ERROR_TYPE: Record<number, ErrorType> = {
  401: 'unauthorized',
  403: 'forbidden',
  404: 'not_found',
};
